export default "__VITE_ASSET__98b98a64__"